/**
 * Hi-ReS! Stats
 *
 * Released under MIT license:
 * http://www.opensource.org/licenses/mit-license.php
 *
 * How to use:
 *
 *    addChild( new Stats() );
 *
 *    or
 *
 *    addChild( new Stats( { bg: 0xffffff } );
 *
 * version log:
 *
 *    09.03.28        2.1        Mr.doob            + Theme support.
 *    09.02.21        2.0        Mr.doob            + Removed Player version, until I know if it's really needed.
 *                                            + Added MAX value (shows Max memory used, useful to spot memory leaks)
 *                                            + Reworked text system / no memory leak (original reason unknown)
 *                                            + Simplified
 *    09.02.07        1.5        Mr.doob            + onRemovedFromStage() (thx huihuicn.xu)
 *    08.12.14        1.4        Mr.doob            + Code optimisations and version info on MOUSE_OVER
 *    08.07.12        1.3        Mr.doob            + Some speed and code optimisations
 *    08.02.15        1.2        Mr.doob            + Class renamed to Stats (previously FPS)
 *    08.01.05        1.2        Mr.doob            + Click changes the fps of flash (half up increases, half down decreases)
 *    08.01.04        1.1        Mr.doob            + Shameless ripoff of Alternativa's FPS look :P
 *                            Theo            + Log shape for MEM
 *                                            + More room for MS
 *     07.12.13        1.0        Mr.doob            + First version
 **/



import Bitmap = createjs.Bitmap;
import BitmapData = createjs.BitmapData;
import Sprite = createjs.Sprite;
import Event = createjs.Event;
import MouseEvent = createjs.MouseEvent;
import Rectangle = createjs.Rectangle;
// TODO: @HTML5 handle System class
// import System = createjs.System;
// TODO: @HTML5 handle StyleSheet class
// import StyleSheet = createjs.StyleSheet;
import TextField = createjs.Text;
import Container = createjs.Container;


/**
 * <b>Hi-ReS! Stats</b> FPS, MS and MEM, all in one.
 */
export class Stats extends Container {
    private _text: TextField;
    private _style: StyleSheet;

    private _timer: number;
    private _fps: number;
    private _ms: number;
    private _ms_prev: number;
    private _mem: number;
    private _mem_max: number;

    private _graph: BitmapData;
    private _rectangle: Rectangle;

    private _fps_graph: number;
    private _mem_graph: number;
    private _mem_max_graph: number;

    private _theme: any = { bg: "#000033", fps: "#ffff00", ms: "#00ff00", mem: "#00ffff", memmax: "#ff0070" };

    /**
     * <b>Hi-ReS! Stats</b> FPS, MS and MEM, all in one.
     *
     * @param theme         Example: { bg: 0x202020, fps: 0xC0C0C0, ms: 0x505050, mem: 0x707070, memmax: 0xA0A0A0 }
     */
    constructor(theme: any = null) {
        super();
        if (theme) {
            if (theme.bg != null) {
                this._theme.bg = theme.bg;
            }

            if (theme.fps != null) {
                this._theme.fps = theme.fps;
            }

            if (theme.ms != null) {
                this._theme.ms = theme.ms;
            }

            if (theme.mem != null) {
                this._theme.mem = theme.mem;
            }

            if (theme.memmax != null) {
                this._theme.memmax = theme.memmax;
            }
        }

        this.addEventListener(Event.ADDED_TO_STAGE, this.bindFunction(this.init));
        this.addEventListener(Event.REMOVED_FROM_STAGE, this.bindFunction(this.kill));
    }

    public kill(e: Event): void {
        this.removeEventListener(Event.ADDED_TO_STAGE, this.bindFunction(this.init));
        this.removeEventListener(Event.REMOVED_FROM_STAGE, this.bindFunction(this.kill));
        this.removeEventListener(MouseEvent.CLICK, this.bindFunction(this.onClick));
        this.removeEventListener(Event.ENTER_FRAME, this.bindFunction(this.update));
    };

    private init(e: Event): void {
        /* TODO: @HTML5 handle TextField class
        this.removeEventListener(Event.ADDED_TO_STAGE, this.init);

        this.graphics.beginFill(this._theme.bg);
        this.graphics.drawRect(0, 0, 70, 50);
        this.graphics.endFill();

        this._mem_max = 0;

        this._xml = "<xml>\r\n\t\t\t\t<fps>FPS:</fps>\r\n\t\t\t\t<ms>MS:</ms>\r\n\t\t\t\t<mem>MEM:</mem>\r\n\t\t\t\t<memMax>MAX:</memMax>\r\n\t\t\t</xml>";

        this._style = new StyleSheet();
        this._style.setStyle("xml", { fontSize: '9px', fontFamily: '_sans', leading: '-2px' });
        this._style.setStyle("fps", { color: this.hex2css(this._theme.fps) });
        this._style.setStyle("ms", { color: this.hex2css(this._theme.ms) });
        this._style.setStyle("mem", { color: this.hex2css(this._theme.mem) });
        this._style.setStyle("memMax", { color: this.hex2css(this._theme.memmax) });

        this._text = new TextField();
        this._text.width = 70;
        this._text.height = 50;
        this._text.styleSheet = this._style;
        this._text.condenseWhite = true;
        this._text.selectable = false;
        this._text.mouseEnabled = false;
        this.addChild(this._text);

        let bitmap: Bitmap = new Bitmap(this._graph = new BitmapData(70, 50, false, this._theme.bg));
        bitmap.y = 50;
        this.addChild(bitmap);

        this._rectangle = new Rectangle(0, 0, 1, this._graph.height);

        this.addEventListener("click", this.onClick);
        this.addEventListener(Event.ENTER_FRAME, this.update);
        */
    };

    private update(e: Event): void {
        /* TODO: @HTML5 handle 'stage.frameRate'
        this._timer = Date.now();

        if (this._timer - 1000 > this._ms_prev) {
            this._ms_prev = this._timer;
            this._mem = Number((System.totalMemory * 0.000000954).toFixed(3));
            this._mem_max = this._mem_max > this._mem ? this._mem_max : this._mem;

            this._fps_graph = Math.min(50, (this._fps / this.stage.frameRate) * 50);
            this._mem_graph = Math.min(50, Math.sqrt(Math.sqrt(this._mem * 5000))) - 2;
            this._mem_max_graph = Math.min(50, Math.sqrt(Math.sqrt(this._mem_max * 5000))) - 2;

            this._graph.scroll(1, 0);

            this._graph.fillRect(this._rectangle, this._theme.bg);
            this._graph.setPixel(0, this._graph.height - this._fps_graph, this._theme.fps);
            this._graph.setPixel(0, this._graph.height - ((this._timer - this._ms) >> 1), this._theme.ms);
            this._graph.setPixel(0, this._graph.height - this._mem_graph, this._theme.mem);
            this._graph.setPixel(0, this._graph.height - this._mem_max_graph, this._theme.memmax);

            this._xml.fps = "FPS: " + this._fps + " / " + this.stage.frameRate;
            this._xml.mem = "MEM: " + this._mem;
            this._xml.memMax = "MAX: " + this._mem_max;

            this._fps = 0;
        }

        this._fps++;

        this._xml.ms = "MS: " + (this._timer - this._ms);
        this._ms = this._timer;

        this._text.htmlText = this._xml;
        */
    };

    private onClick(e: MouseEvent): void {
        /* TODO: @HTML5 handle 'stage.frameRate'
        this.mouseY / this.height > .5 ? this.stage.frameRate-- : this.stage.frameRate++;
        this._xml.fps = "FPS: " + this._fps + " / " + this.stage.frameRate;
        this._text.htmlText = this._xml;
        */
    };

    // .. Utils

    private hex2css(color: number): string {
        return "#" + color.toString(16);
    }
}

